import * as React from "react";
const IconReschedule = (props) => (
  <svg
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.2891 9C17.2891 13.3492 13.7633 16.875 9.41406 16.875C5.06482 16.875 1.53906 13.3492 1.53906 9C1.53906 4.65076 5.06482 1.125 9.41406 1.125C12.3289 1.125 14.8739 2.70866 16.2355 5.0625M16.2355 5.0625V1.125M16.2355 5.0625H12.3672"
      stroke="#DB5800"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default IconReschedule;
